export default (params) => {
  let rating = "empty";

  params.ratings.forEach((rat) => {
    if (rat.section === params.section) {
      switch (rat.rating) {
        case 1:
          rating = "good";
          break;

        case 2:
          rating = "medium";
          break;

        case 3:
          rating = "bad";
          break;

        default:
          break;
      }
    }
  });

  if (params.qnst && params.qnst.questions) {
    const unansweredQuestions = params.qnst.questions.filter((q) =>
      params.status == 6 &&
      (q.section_text === "Engagement Leader" || q.section_text === "Manager")
        ? false
        : q.answered === false
    );

    if (unansweredQuestions.length > 0 && params.showError) {
      rating = rating.concat(" answer-to-apply");
    }
  }

  return rating;
};
